import React, {
  FC,
} from 'react';
import { FaXmark } from 'react-icons/fa6';
import {
  Row, Button,
  Wrapper,
} from './Styles';
import TermsOfUseContent from '../../../../components/TermsOfUseContent';

const TermsConditionsModal: FC<Props> = ({
  showAgreeBtn,
  showExitBtn,
  callback,
  isEnglish,
  agreeLangZH,
  agreeLangEN,
  exitLangZH,
  exitLangEN,
}) => {

  /* 条款与条件弹窗 */
  return (
    <Wrapper>
      <div style={{ width: '100%', height: '90%', background: '#ffffff', position: 'fixed', bottom: 0, zIndex: 3 }}>
        {/* 标题 */}
        <Row style={{ justifyContent: 'space-between', marginTop: '5%' }}>
          <div style={{ width: '20px', height: '20px' }}>&nbsp;</div>
          {
            isEnglish ? (
              <div style={{ minHeight: '20px', fontSize: '20px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '26px', textAlign: 'center' }}>
                Terms of Use and<br />Privacy Policy
              </div>
            ) : (
              <div style={{ minHeight: '20px', fontSize: '20px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '28px' }}>
                使用条款
              </div>
            )
          }
          <Button
            onClick={() => {
              callback(false);
            }}
            style={{ height: '20px', width: '20px', marginRight: '10px', fontSize: '16px' }}
          >
            <FaXmark color={'#000000'} />
          </Button>
        </Row>

        {/* 横线 */}
        <div style={{ width: '90%', height: '2px', background: '#11202B', opacity: 0.1, margin: '5% auto 0 auto' }}></div>

        {/* 英文条款 */}
        <div style={{ width: '90%', height: '90%', overflow: 'auto', marginTop: '10px', marginLeft: 'auto', marginRight: 'auto', textAlign: 'left' }}>
          <TermsOfUseContent />
        </div>
      </div>

      {/* 统一协议按钮 */}
      {
        (showAgreeBtn || showExitBtn) && (
          <>
            <div style={{ width: '100%', background: '#ffffff', position: 'fixed', bottom: 0, zIndex: 3 }}>
              <div style={{ width: '90%', height: '1px', background: '#11202B', opacity: 0.1, marginLeft: '5%', marginTop: '10px' }}></div>
              <Row style={{ width: '90%', height: '90px', paddingBottom: 5, marginLeft: '5%', justifyContent: 'center', alignItems: 'center' }}>
                {/* 同意条款 */}
                {
                  showAgreeBtn && (
                    <Button
                      onClick={() => {
                        callback(true);
                      }}
                      style={{ width: '164px', height: '51px', background: '#00D2B9', borderRadius: 5 }}
                    >
                      {
                        isEnglish ? (
                          <div style={{ fontSize: '20px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '26px' }}>
                            {agreeLangEN || 'Agree'}
                          </div>
                        ) : (
                          <div style={{ fontSize: '20px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '28px' }}>
                            {agreeLangZH || '同意'}
                          </div>
                        )
                      }
                    </Button>
                  )
                }
                {/* 关闭条款与条件 */}
                {
                  showExitBtn && (
                    <Button
                      onClick={() => {
                        callback(false);
                      }}
                      style={{ width: '164px', height: '51px', background: '#11202B', borderRadius: 5, marginLeft: '15px' }}
                    >
                      {
                        isEnglish ? (
                          <div style={{ fontSize: '20px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '26px' }}>
                            {exitLangEN || 'Exit'}
                          </div>
                        ) : (
                          <div style={{ fontSize: '20px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '28px' }}>
                            {exitLangZH || '退出'}
                          </div>
                        )
                      }
                    </Button>
                  )
                }
              </Row>
            </div>
          </>
        )
      }
    </Wrapper>
  );
};

export interface Props {
  showAgreeBtn: boolean;
  showExitBtn: boolean;
  callback: (isAgree: boolean) => void;
  isEnglish: boolean;
  agreeLangEN?: string;
  agreeLangZH?: string;
  exitLangEN?: string;
  exitLangZH?: string;
}

export default TermsConditionsModal;
